import React from 'react'
import { LuMonitor, LuLayers, LuSchool } from 'react-icons/lu'
import DeliveryImg from '../Assets/flexibleDelievery.jpg'

const FlexibleDelieveryData = [
  {
    heading: 'Online Learning',
    para: 'Flexible and accessible online courses delivered through interactive platforms and learning management systems.',
    Icon: LuMonitor,
  },
  {
    heading: 'Blended Learning',
    para: 'A combination of online and in-person instruction, providing a dynamic and engaging learning experience.',
    Icon: LuLayers,
  },
  {
    heading: 'On-Campus Programs',
    para: 'Traditional on-campus programs for students who prefer a structured and immersive learning environment.',
    Icon: LuSchool,
  },
]

const FlexibleDelievery = () => {
  return (
    <section className='home_section'>
      <span className='home_eyebrow'>Delivery</span>
      <h2 className='home_heading'>Flexible delivery</h2>
      <p className='home_lead'>Learn the way that suits you, online, blended, or on campus.</p>

      <div className='bento'>
        <div
          className='bento_card span-3 bento_image'
          style={{ backgroundImage: `url(${DeliveryImg})`, gridRow: 'span 2' }}
          role='img'
          aria-label='Students in a flexible learning environment'
        />
        {FlexibleDelieveryData.map(({ Icon, heading, para }, index) => (
          <div className={`bento_card span-3${index === 0 ? ' tone-soft' : ''}`} key={index}>
            <Icon className='bento_icon' />
            <h3 className='bento_title'>{heading}</h3>
            <p className='bento_para'>{para}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default FlexibleDelievery
